var map = {
	"./computer/Token/Token.vue": [
		"83d4",
		"chunk-22ae6cda",
		"chunk-5bf9cb27"
	],
	"./mobile/Token/Token.vue": [
		"e488",
		"chunk-22ae6cda",
		"chunk-e0f724c6"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f668";
module.exports = webpackAsyncContext;